export default {
  pagination: {},
  comment: null,
  comments: []
};
